import { type FC, useCallback } from 'react';

import { FaceSmileIcon } from '@heroicons/react/24/outline';
import type { Editor } from '@tiptap/react';

import { ICON_CLASS, tr } from '../constants';
import { EmojiPicker } from '../EmojiPicker';
import { PanelPopover } from './PanelPopover';

interface EmojiPanelProps {
  editor: Editor;
  translations?: Record<string, string>;
}

export const EmojiPanel: FC<EmojiPanelProps> = ({ editor, translations }) => {
  const handleSelect = useCallback(
    (emoji: string, close: () => void) => {
      editor.chain().focus().insertContent(emoji).run();
      close();
    },
    [editor],
  );

  return (
    <PanelPopover
      triggerLabel={tr(translations, 'community.composer.add_emoji')}
      triggerIcon={<FaceSmileIcon className={ICON_CLASS} aria-hidden="true" />}
      panelClassName="w-80"
    >
      {({ close }) => (
        <EmojiPicker
          onSelect={(emoji) => handleSelect(emoji, close)}
          labels={{
            searchPlaceholder: tr(translations, 'community.composer.emoji_search_placeholder'),
            noResults: tr(translations, 'community.composer.emoji_no_results'),
          }}
        />
      )}
    </PanelPopover>
  );
};
